import getRootDomain from '@/lib/getRootDomain';

export const protocol =
  process.env.NODE_ENV === 'production' ? 'https' : 'http';
export const rootDomain = getRootDomain();
